import { AlertColor, useMediaQuery, useTheme } from '@mui/material';
import Notification from 'components/Notification';
import React, { useState } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useDispatch, useSelector } from 'react-redux';
import { getDrawerWidth } from 'utils/validators/HelperFunctions';
import DrawerMenu from '../../../components/DrawerMenu';
import Login from '../../../screens/Authentication/Login';
import {
  openAuthenticationDrawer,
  setOpenAuthenticationDrawer,
} from '../../../utils/redux/reducer/authentication-slice';
import ForgotPassword from '../ForgotPassword';
import SignUp from '../SignUp';
import { fetchFromStorage } from 'utils/storage';
import GuestUser from '../GuestUser';
import { identifiers } from 'utils/constants/identifiers';

const RenderedComponent = ({ drawerState, setDrawerState, handleClose, setMessage, embedded }: any) => {
  if (drawerState === 1) {
    return embedded  ? (
      <GuestUser handleClose={handleClose} setDrawerState={setDrawerState} setMessage={setMessage} />
    ) : (
      <Login handleClose={handleClose} setDrawerState={setDrawerState} />
    );
  } else if (drawerState === 2) {
    return <ForgotPassword handleClose={handleClose} setDrawerState={setDrawerState} setDrawerMessage={setMessage} />;
  } else {
    return <SignUp setDrawerState={setDrawerState} setMessage={setMessage} />;
  }
};

const AuthenticationDrawer = () => {
  const initialData = JSON.parse(fetchFromStorage('initialData') as string);
  const theme = useTheme();
  const screenSizeDownSm = useMediaQuery(theme.breakpoints.down('sm'));
  const screenSizeDownMd = useMediaQuery(theme.breakpoints.down('md'));
  const screenSizeUpLg = useMediaQuery(theme.breakpoints.up('lg'));
  // drawerState 1 = Login
  // drawerState 2 = Forgot Password
  // drawerState 1 = Sign Up
  const [drawerState, setDrawerState] = useState<1 | 2 | 3>(1);
  const openDrawer = useSelector(openAuthenticationDrawer);
  const dispatch = useDispatch();
  const [message, setMessage] = React.useState<{
    display: boolean;
    severity: AlertColor | null;
    message: any;
  }>({
    display: false,
    severity: null,
    message: '',
  });
  const closeNotification = (value: boolean) => {
    setMessage({ ...message, display: value });
  };

  const handleClose = () => {
    setDrawerState(1);
    dispatch(setOpenAuthenticationDrawer(false));
  };
  return (
    <>
      {message && message.display && (
        <Notification
          isOpen={message.display}
          message={message.message}
          severity={message.severity as AlertColor}
          closeNotification={closeNotification}
        />
      )}
      <DrawerMenu
        open={openDrawer}
        handleClose={handleClose}
        width={getDrawerWidth(screenSizeDownSm, screenSizeDownMd, screenSizeUpLg)}
        drawerState={drawerState}>
        <GoogleReCaptchaProvider
          reCaptchaKey={identifiers.REACT_APP_GOOGLE_RECAPTCHA}
          scriptProps={{
            async: true,
            defer: true,
            appendTo: 'head',
          }}>
          <RenderedComponent
            embedded={initialData?.embedded}
            drawerState={drawerState}
            setDrawerState={setDrawerState}
            handleClose={handleClose}
            setMessage={setMessage}
          />
        </GoogleReCaptchaProvider>
      </DrawerMenu>
    </>
  );
};

export default AuthenticationDrawer;
